module.exports = __webpack_public_path__ + "img/4-2zhiliang.2d09972f.png";